import React from "react";

export const AppFooter = (props) => {
  const onClickCookies = (e) => {
    props.onClickCookies(e);
  };
  return (
    <div className="flex " style={{ backgroundColor: "white",borderTop: "1px solid #ccc"}}>
      <div className="col-2 text-sm font-medium text-500" >
         <img style={{ maxHeight: "40pt" }} src="assets/layout/images/mic.png" alt="logo" />
      </div>
      <div className="mt-2 p-3 col-8">
       <div className="text-center text-sm font-medium  mb-2">
        <img style={{ maxHeight: "80pt" }} src="assets/layout/images/footer1.png" alt="logo" />
        
       </div>

      </div>
      <div className="col-2 text-sm font-medium text-500" style={{ cursor: "pointer" }} onClick={onClickCookies}>
          Cookie Policy
      </div>
    </div>

    /*
        We use cookies on our website to give you the most relevant experience by remembering
         your preferences and repeat visits. By clicking “Accept”, you consent to the use of ALL the cookies.


         https://ownyourbusiness.tech/it/cookies/
    */
  );
};
